import * as React from "react";
import { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import StyledGrid, { FilterChip } from "../../../shared/components/StyledGrid";

import useFetchWithMsal from "../../../utils/useFetchWithMsal";
import { useSelector } from "react-redux";
import { Typography } from "@mui/material";
import { TableFilter } from "../../../components/tableFilter/TableFilter";
import { LoadingPanel } from "../../../shared/components/LoadingPanel";
import { insolventColumns } from "../../../constants/TablesColumns";
import { useGetInsolventsMutation } from "../../../services/InsuranceService";


export const InsolventTab = () => {

  const roleId = useSelector((state) => state?.user?.roleId);

  const { skip } = useFetchWithMsal();

  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 50,
  });
  const [totalCount, setTotalCount] = useState(0);

  const [sortingModel, setSortingModel] = useState();
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [isShowClassAPopup, setIsShowClassAPopup] = useState(false);
  const [isShowClassBPopup, setIsShowClassBPopup] = useState(false);
  const [isAddItemDropdownVisible, setIsAddItemDropdownVisible] = useState(false);

  const [rowData, setRowData] = useState({});
  const [getInsolvents, { data, isLoading }] = useGetInsolventsMutation("", { skip });

  const { naicCode,memberName } = useSelector(
    (state) => state.filter
  );

  useEffect(() => {
    fetchData()
  }, [
    paginationModel.page,
    paginationModel.pageSize,
    sortingModel?.field,
    sortingModel?.sort,
  ]);

  useEffect(() => {
    setIsAddItemDropdownVisible(false);
  }, [isShowClassAPopup, isShowClassBPopup]);

  useEffect(() => {
    if (!isLoading) {
      if (data?.totalCount !== totalCount) {
        setTotalCount(data?.totalCount);
      }
    }
  }, [isLoading]);

  const fetchData = (value) => {
    const body = {
      page: paginationModel.page + 1,
      pageSize: paginationModel.pageSize,
      orderBy: sortingModel?.field || "",
      orderByDirection: sortingModel?.sort || "",
      naicCode: value? value.naicCode : naicCode,
      memberName: value? value.memberName : memberName
    };
    getInsolvents(body);
  };
  const handlePaginationModelChange = (newPaginationModel) => {
    setPaginationModel(newPaginationModel);
  };

  const onApplyFilters = (value) => {
    if(paginationModel.page){
      setPaginationModel(prev => { return {...prev, page:0}})

    } else {
     fetchData(value)
    }

    // getClients({
    //   recordNumber: page * rowsPerPage,
    //   offset: rowsPerPage,
    //   status: resetFilter === 'status' ? '' : status,
    //   counselor: resetFilter === 'counselor' ? '' : counselor,
    //   housing: resetFilter === 'housing' ? '' : housing
    // })
  };

  const onRowClick =(e)=>{
    setRowData(e.row)
    console.log(e.row)
    setIsPopupOpen(true)
  }
  // const onClosePopup =()=>{
  //   setIsPopupOpen(false)

  // }

  const onPopupClose = () => {
    setIsShowClassAPopup(false);
    setIsShowClassBPopup(false)
  };
  return (
    <Box sx={{ height: "100%", width: "100%", margin: "50px auto 0 auto" }}>
      {isLoading && <LoadingPanel />}
      <Box display={"flex"} sx={{ justifyContent: "space-between" }} mb={3}>
        <Typography variant="h1" color="primary.main" sx={{ marginLeft: "16px" }}>
          Insolvents
        </Typography>
        <Box display={"flex"}>
        <TableFilter onApplyFilters={onApplyFilters} type = 'assessment'/>
      
        </Box>
      </Box>
      <Box
        sx={{
          display: "flex",
          gap: 1,
          flexWrap: "wrap",
          alignItems: "center",
          marginRight: "15px",
          marginBottom: "15px",
        }}
      >
        {naicCode && <FilterChip>NAIC Code: {naicCode}</FilterChip>}
        {memberName && <FilterChip>Insolvent Company: {memberName}</FilterChip>}
      </Box>
      <StyledGrid
        data={data?.assesments}
        width="100%"
        columns={insolventColumns}
        rowCount={totalCount}
        onSortingModelChange={(model) => setSortingModel(model[0])}
        paginationModel={paginationModel}
        setPaginationModel={handlePaginationModelChange}
        onRowClick={onRowClick}
        // withMenu
      />
    </Box>
  );
};
